import { MAX_FLEET_SIZE } from '@folio/constants';
import { useQuery } from '@tanstack/react-query';
import {
  type Asset,
  type KeyValueFieldObject,
  keyValueFieldsToObject,
  viewSpecificControllerListPolicyAssetsQueryOptions,
} from 'korint-sdk';

export function getLatestAsset(data: Asset[]) {
  return data?.sort(({ createdAt: created1 }, { createdAt: created2 }) => {
    const date1 = created1 ? new Date(created1).getTime() : 0;
    const date2 = created2 ? new Date(created2).getTime() : 0;

    return date2 - date1;
  })[0];
}

export function useCurrentActiveAsset<TCustomFields extends KeyValueFieldObject>({
  policyId,
  branchId,
}: {
  policyId: string;
  branchId?: string;
}) {
  return useQuery({
    ...viewSpecificControllerListPolicyAssetsQueryOptions(policyId, {
      branchId,
      count: MAX_FLEET_SIZE,
    }),
    enabled: !!policyId,
    select: data => {
      return getLatestAsset(
        data.data.map(asset => ({
          ...asset,
          customFields: keyValueFieldsToObject<TCustomFields>(asset.customFields ?? []),
        })),
      );
    },
  });
}
